import localeAntd from 'ant-design-vue/lib/locale-provider/th_TH';
const messages = {
    topBar: {
        issuesHistory: 'Issues History',
        projectManagement: 'Project Management',
        typeToSearch: 'Search...',
        findPages: 'Find pages...',
        actions: 'Actions',
        status: 'Status',
        profileMenu: {
            hello: 'Hello',
            billingPlan: 'Billing Plan',
            role: 'Role',
            email: 'Email',
            phone: 'Phone',
            editProfile: 'Edit Profile',
            logout: 'Logout',
        },
    },
    'Welcome To': 'ยินดีต้อนรับสู่',
    Name: 'ชื่อ',
    'Slug Name': 'ชื่อย่อ',
    Mobile: 'เบอร์โทรศัพท์',
    'Card ID': 'Card ID',
    ' Card ID': ' Card ID',
    Surname: 'นามสกุล',
    'House No': 'บ้านเลขที่',
    Swine: 'หมู่ที่',
    Village: 'หมู่บ้าน',
    'Sub District': 'ตำบล',
    District: 'อำเภอ',
    Province: 'จังหวัด',
    'Birth Date': 'วันเกิด',
    Username: 'ชื่อผู้ใช้',
    Email: 'อีเมล',
    'Save Success!': 'บันทึกสำเร็จ!',
    Home: 'หน้าหลัก',
    'Main Menu': 'เมนูหลัก',
    'Find Users': 'ค้นหาผู้ใช้',
    'User Info': 'ข้อมูลผู้ใช้',
    Save: 'บันทึก',
    'Please input your ': 'กรุณากรอก',
    'Profile Image': 'รูปโปรไฟล์',
    Search: 'ค้นหา',
    'Sign in': 'เข้าสู่ระบบ',
    Password: 'รหัสผ่าน',
    'SCG Debenture Club': 'ระบบบริหารจัดการและติดตามโครงการ',
    '10m Family': 'โครงการ 10 ล้านครอบครัว ฯ',
    'Total Registers': 'จำนวนผู้สมัครทั้งหมด',
    'Total Calories': 'สะสมพลังงานทั้งหมด',
    'Kilocalorie(s)': 'กิโลแคลอรี',
    'Affiliation(s)': 'สังกัด',
    People: 'คน',
    'Kilometer(s)': 'กิโลเมตร',
    'Minute(s)': 'นาที',
    Reports: 'รายงาน',
    'Summary report': 'รายงานสรุป',
    'Operation Detail Report': 'รายงานรายละเอียดการดำเนินงาน',
    'Contract Management Report': 'รายงานผลการบริหารสัญญา',
    'Contract Management / Tracking Report': 'รายงานผลการบริหาร/ติดตามสัญญา',
    'Disbursement Result Report': 'รายงานผลการเบิกจ่าย',
    'Project Disbursement Report': 'รายงานผลการเบิกจ่ายรายโครงการ',
    Type: 'ประเภท',
    Goals: 'เป้าหมาย',
    Activities: 'กิจกรรม',
    'Exercise All Over 800m': 'สะสมระยะเวลาครบ 800 นาที',
    'Run Over 80km': 'สะสมระยะทางวิ่ง',
    'Bike Over 300km': 'สะสมระยะทางปั่นจักรยาน',
    'Exercise All Over 6000cal': 'สะสมพลังงานครบ 6,000 กิโลแคลอรี',
    'Top 10 Provinces Registration': '10 อันดับจังหวัด จำนวนผู้สมัครสูงสุด',
    'Top 10 Provinces Registration Percentage':
        '10 อันดับจังหวัด อัตราผู้สมัครสูงสุด',
    Unknown: 'ไม่ระบุ',
    'Save Fail!': 'บันทึกไม่สำเร็จ!',
    'Find Groups': 'ค้นหากลุ่ม',
    Ok: 'ตกลง',
    Reset: 'รีเซต',
    'No Data': 'ไม่พบข้อมูล',
    Keyword: 'คำสำคัญ',
    'Members Count': 'จำนวนสมาชิก',
    Verified: 'ได้รับการยืนยัน',
    Yes: 'ใช่',
    No: 'ไม่',
    Owner: 'เจ้าของ',
    'Group Info': 'ข้อมูลกลุ่ม',
    'Delete User': 'ลบผู้ใช้',
    Cancel: 'ยกเลิก',
    'Are you sure delete this user?': 'คุณแน่ว่าต้องการลบผู้ใช้นี้?',
    'Delete Success!': 'ลบสำเร็จ!',
    'Delete Fail!': 'ลบไม่สำเร็จ!',
    Date: 'วันที่',
    'Date and Time': 'วันที่และเวลา',
    Distance: 'ระยะทาง',
    'Time Usage': 'เวลาที่ใช้',
    'Calorie(s)': 'แคลอรี',
    Actions: 'การปฏิบัติ',
    Remove: 'ลบ',
    Weight: 'น้ำหนัก',
    Height: 'ส่วนสูง',
    'User Count': 'จำนวนผู้ใช้',
    'Total Distances': 'สะสมระยะทางทั้งหมด',
    'Total Time Usage': 'สะสมระยะเวลาทั้งหมด',
    'Random User Names': 'การสุ่มรายชื่อ',
    'Random From Activities': 'สุ่มจากกิจกรรม',
    'Random From Every Week': 'สุ่มจากการส่งกิจกรรมทุกสัปดาห์',
    'Random From SS1 And SS2': 'สุ่มจาก SS1 และ SS2',
    'Number Of Users': 'จำนวนผู้ใช้',
    Random: 'สุ่ม',
    Weeks: 'สัปดาห์',
    'Week 1 to 4': 'สัปดาห์ที่ 1-4',
    'Week 5 to 8': 'สัปดาห์ที่ 5-8',
    'Please select your ': 'กรุณาเลือก',
    Dashboard: 'แดชบอร์ด',
    'Select Zone': 'เลือกเขตสุขภาพ',
    'Select Province': 'เลือกจังหวัด',
    'Select District': 'เลือกอำเภอ',
    Data: 'ข้อมูล',
    'Walk Run (People)': 'เดินวิ่ง (คน)',
    'Cycling (People)': 'ปั่นจักยาน (คน)',
    'Aerobic (People)': 'แอโรบิค (คน)',
    'Kita Muay Thai (People)': 'คีตะมวยไทย (คน)',
    'Weight Training (People)': 'เวทเทรนนิ่ง (คน)',
    'Yoga (People)': 'โยคะ (คน)',
    'Project Info Management': 'จัดการข้อมูลโครงการ',
    'Report System': 'ระบบรายงาน',
    'Procurement Report': 'รายงานการจัดซื้อจัดจ้าง',
    'User Management': 'จัดการข้อมูลผู้ใช้',
    'Division Management': 'จัดการข้อมูลฝ่าย',
    'Basic Info Management': 'จัดการข้อมูลพื้นฐาน',
    'Procurement Type Info': 'ข้อมูลประเภทจัดชื้อจัดจ้าง',
    'Inspection Type Info': 'ข้อมูลประเภทการตรวจรับ',
    'Plan Info': 'ข้อมูลแผนจัดซื้อจัดจ้าง',
    'Holiday Info': 'ข้อมูลวันหยุด',
    'Vendor Info': 'ข้อมูลผู้รับจ้าง',
    'Vendor Name': 'ชื่อผู้รับจ้าง',
    'Role Management': 'จัดการบทบาท',
    'Config Notify': 'ตั้งค่าการแจ้งเตือน',
    'Project Management': 'จัดการข้อมูลโครงการ',
    'Page not found': 'ไม่พบหน้า',
    'This page is deprecated, deleted, or does not exist at all':
        'หน้านี้เลิกใช้งาน หรือถูกลบ หรือไม่มีอยู่เลย',
    'Go Back': 'กลับไป',
    'Project Name': 'ชื่อโครงการ',
    Status: 'สถานะ',
    'Contact No.': 'เลขที่สัญญา',
    'Start Date': 'เริ่มต้น',
    'End Date': 'สิ้นสุด',
    Budget: 'งบประมาณ',
    'Budget (Plan)': 'งบประมาณ (แผน)',
    'Budget (Contact))': 'งบประมาณ (สัญญา)',
    Disbursement: 'การเบิกจ่าย',
    Vendor: 'ผู้รับจ้าง',
    'Responsible Name': 'ผู้รับผิดชอบ',
    Manage: 'จัดการ',
    'Fiscal Year (B.E.)': 'ปีงบประมาณ',
    'Start Date of Project': 'วันที่เริ่มต้นโครงการ',
    'Work Plan': 'แผนจัดซื้อจัดจ้าง',
    'Work Plan Name': 'แผนจัดซื้อจัดจ้าง',
    'End Date of Project': 'วันที่สิ้นสุดโครงการ',
    Add: 'เพิ่ม',
    'Add User': 'เพิ่มผู้ใช้งาน',
    Delete: 'ลบ',
    'Add/Edit': 'เพิ่ม/แก้ใข',
    'View Data': 'ดูข้อมูล',
    'Create Data': 'เพิ่มข้อมูล',
    'Update Data': 'แก้ใขข้อมูล',
    'Delete Data': 'ลบข้อมูล',
    'Add Project': 'เพิ่มโครงการ',
    'Add or Edit Project': 'เพิ่ม/แก้ไขโครงการ',
    'Menu Name': 'ชื่อเมนู',
    'Project Detail': 'ข้อมูลโครงการ',
    'Purchase Record': 'บันทึกการจัดซื้อจัดจ้าง',
    'Inspection Record': 'บันทึกการตรวจรับ',
    'Disbursement Record': 'บันทึกการเบิกจ่าย',
    'Procurement Type Name': 'ชื่อประเภทจัดชื้อจัดจ้าง',
    'Procurement Step': 'ขั้นตอนจัดชื้อจัดจ้าง',
    'Procurement Step Name': 'ชื่อขั้นตอนจัดชื้อจัดจ้าง',
    'Inspection Type Name': 'ชื่อประเภทการตรวจรับ',
    'Inspection Step': 'ขั้นตอนการตรวจรับ',
    'Inspection Step Data': 'ข้อมูลขั้นตอนการตรวจรับ',
    'Inspection Step Name': 'ชื่อขั้นตอนการตรวจรับ',
    Step: 'ขั้นตอน',
    'Plan Name': 'ชื่อแผนจัดซื้อจัดจ้าง',
    'holiday Name': 'ชื่อวันหยุด',
    'Weekly Holiday': 'วันหยุดประจำสัปดาห์',
    'Public Holidays': 'วันหยุดนักขัตฤกษ์',
    'Public Holidays Name': 'ชื่อวันหยุดนักขัตฤกษ์',
    created_at: 'บันทึกเมื่อ',
    created_by: 'บันทึกโดย',
    'Order Manage': 'จัดการลำดับ',
    active: 'ใช้งาน',
    'in-active': 'ยกเลิกใช้งาน',
    Division: 'ฝ่าย',
    'Division Name': 'ชื่อฝ่าย',
    Edit: 'แก้ไข',
    'Loading...': 'กำลังโหลด...',
    'Add Success!': 'เพิ่มสำเร็จ!',
    'Add Fail!': 'เพิ่มไม่สำเร็จ!',
    'Please select item for delete.': 'กรุณาเลือกเพื่อลบ',
    'Do you want to delete these items?': 'ยืนยันการลบ?',
    'Project Code': 'รหัสโครงการ',
    Manual: 'คู่มือ',
    Code: 'รหัสแผน',
    'LINE Sign in': 'เข้าสู่ระบบด้วย LINE',
    'Wrong Password': 'รหัสไม่ถูกต้อง',
    'Correct Password': 'รหัสถูกต้อง',
    Confirm: 'ยืนยัน'
};
export default {
    locale: 'th-TH',
    localeAntd,
    messages,
};